/* eslint-env browser */
// @flow
import type { Node } from 'react';
import { Component } from 'react';
import { withRouter } from 'react-router';

type ScrollToTopProps = {
  location: Object,
  children: Node,
};

class ScrollToTop extends Component<ScrollToTopProps, *> {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
